/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {ArchiveChannelStateResponse} from "../model/archive-channel-state-response";
import {ChangeCameraViewModeRequest} from "../model/change-camera-view-mode-request";
import {ChangePlayerRoomPresetRequest} from "../model/change-player-room-preset-request";
import {ConnectTabletToPlayerRequest} from "../model/connect-tablet-to-player-request";
import {DimScreenRequest} from "../model/dim-screen-request";
import {JumpToRequest} from "../model/jump-to-request";
import {PauseRequest} from "../model/pause-request";
import {PlayRequest} from "../model/play-request";
import {PowerpointNavigateBackwardRequest} from "../model/powerpoint-navigate-backward-request";
import {PowerpointNavigateForwardRequest} from "../model/powerpoint-navigate-forward-request";
import {ScrollPdfDownRequest} from "../model/scroll-pdf-down-request";
import {ScrollPdfUpRequest} from "../model/scroll-pdf-up-request";
import {SetGroupVolumeArchiveRequest} from "../model/set-group-volume-archive-request";
import {SetGroupVolumeRequest} from "../model/set-group-volume-request";
import {SetMediaFileLoopingRequest} from "../model/set-media-file-looping-request";
import {SetVolumeArchiveRequest} from "../model/set-volume-archive-request";
import {SetVolumeRequest} from "../model/set-volume-request";
import {StartDebriefingRequest} from "../model/start-debriefing-request";
import {StartDebriefingResponse} from "../model/start-debriefing-response";
import {StopDebriefingRequest} from "../model/stop-debriefing-request";
import {ToggleGroupMuteArchiveRequest} from "../model/toggle-group-mute-archive-request";
import {ToggleGroupMuteRequest} from "../model/toggle-group-mute-request";
import {ToggleGroupSoloArchiveRequest} from "../model/toggle-group-solo-archive-request";
import {ToggleGroupSoloRequest} from "../model/toggle-group-solo-request";
import {ToggleMuteArchiveRequest} from "../model/toggle-mute-archive-request";
import {ToggleMuteLiveStreamRequest} from "../model/toggle-mute-live-stream-request";
import {ToggleMuteRequest} from "../model/toggle-mute-request";
import {ToggleSoloArchiveRequest} from "../model/toggle-solo-archive-request";
import {ToggleSoloRequest} from "../model/toggle-solo-request";
import {UpdateLivestreamVolumeRequest} from "../model/update-livestream-volume-request";
import {UpdateShowAbsoluteTimeRequest} from "../model/update-show-absolute-time-request";

@Injectable({
    providedIn: "root",
})
export class SimDebriefingService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public changeCameraViewMode(request: ChangeCameraViewModeRequest) {
        return super.post<boolean>(`/api/Debriefing/ChangeCameraViewMode`, request);
    }

    public changePlayerRoomPreset(request: ChangePlayerRoomPresetRequest) {
        return super.post<boolean>(`/api/Debriefing/ChangePlayerRoomPreset`, request);
    }

    public connectTabletToPlayer(request: ConnectTabletToPlayerRequest) {
        return super.post<boolean>(`/api/Debriefing/ConnectTabletToPlayer`, request);
    }

    public dimScreen(request: DimScreenRequest) {
        return super.post<boolean>(`/api/Debriefing/DimScreen`, request);
    }

    public disconnectTabletFromPlayer(request: ConnectTabletToPlayerRequest) {
        return super.post<boolean>(`/api/Debriefing/DisconnectTabletFromPlayer`, request);
    }

    public jumpTo(request: JumpToRequest) {
        return super.post<boolean>(`/api/Debriefing/JumpTo`, request);
    }

    public pause(request: PauseRequest) {
        return super.post<boolean>(`/api/Debriefing/Pause`, request);
    }

    public play(request: PlayRequest) {
        return super.post<boolean>(`/api/Debriefing/Play`, request);
    }

    public powerpointNavigateBackward(request: PowerpointNavigateBackwardRequest) {
        return super.post<boolean>(`/api/Debriefing/PowerpointNavigateBackward`, request);
    }

    public powerpointNavigateForward(request: PowerpointNavigateForwardRequest) {
        return super.post<boolean>(`/api/Debriefing/PowerpointNavigateForward`, request);
    }

    public scrollPdfDown(request: ScrollPdfDownRequest) {
        return super.post<boolean>(`/api/Debriefing/ScrollPdfDown`, request);
    }

    public scrollPdfUp(request: ScrollPdfUpRequest) {
        return super.post<boolean>(`/api/Debriefing/ScrollPdfUp`, request);
    }

    public setGroupVolume(request: SetGroupVolumeRequest) {
        return super.post<boolean>(`/api/Debriefing/SetGroupVolume`, request);
    }

    public setGroupVolumeArchive(request: SetGroupVolumeArchiveRequest) {
        return super.post<ArchiveChannelStateResponse>(`/api/Debriefing/SetGroupVolumeArchive`, request);
    }

    public setMediaFileLooping(request: SetMediaFileLoopingRequest) {
        return super.post<boolean>(`/api/Debriefing/SetMediaFileLooping`, request);
    }

    public setShowAbsoluteTime(request: UpdateShowAbsoluteTimeRequest) {
        return super.post<boolean>(`/api/Debriefing/SetShowAbsoluteTime`, request);
    }

    public setVolume(request: SetVolumeRequest) {
        return super.post<boolean>(`/api/Debriefing/SetVolume`, request);
    }

    public setVolumeArchive(request: SetVolumeArchiveRequest) {
        return super.post<ArchiveChannelStateResponse>(`/api/Debriefing/SetVolumeArchive`, request);
    }

    public startDebriefing(request: StartDebriefingRequest) {
        return super.post<StartDebriefingResponse>(`/api/Debriefing/StartDebriefing`, request);
    }

    public stopDebriefing(request: StopDebriefingRequest) {
        return super.post<boolean>(`/api/Debriefing/StopDebriefing`, request);
    }

    public toggleGroupMute(request: ToggleGroupMuteRequest) {
        return super.post<boolean>(`/api/Debriefing/ToggleGroupMute`, request);
    }

    public toggleGroupMuteArchive(request: ToggleGroupMuteArchiveRequest) {
        return super.post<ArchiveChannelStateResponse>(`/api/Debriefing/ToggleGroupMuteArchive`, request);
    }

    public toggleGroupSolo(request: ToggleGroupSoloRequest) {
        return super.post<boolean>(`/api/Debriefing/ToggleGroupSolo`, request);
    }

    public toggleGroupSoloArchive(request: ToggleGroupSoloArchiveRequest) {
        return super.post<ArchiveChannelStateResponse>(`/api/Debriefing/ToggleGroupSoloArchive`, request);
    }

    public toggleMute(request: ToggleMuteRequest) {
        return super.post<boolean>(`/api/Debriefing/ToggleMute`, request);
    }

    public toggleMuteArchive(request: ToggleMuteArchiveRequest) {
        return super.post<ArchiveChannelStateResponse>(`/api/Debriefing/ToggleMuteArchive`, request);
    }

    public toggleMuteLiveStream(request: ToggleMuteLiveStreamRequest) {
        return super.post<boolean>(`/api/Debriefing/ToggleMuteLiveStream`, request);
    }

    public toggleSolo(request: ToggleSoloRequest) {
        return super.post<boolean>(`/api/Debriefing/ToggleSolo`, request);
    }

    public toggleSoloArchive(request: ToggleSoloArchiveRequest) {
        return super.post<ArchiveChannelStateResponse>(`/api/Debriefing/ToggleSoloArchive`, request);
    }

    public updateLivestreamVolume(request: UpdateLivestreamVolumeRequest) {
        return super.post<boolean>(`/api/Debriefing/UpdateLivestreamVolume`, request);
    }
}